<template>
  <div>
    <vx-card ref="listCard" :title="$t('MRMR.Variances.Title')"  class="mb-3" title-color="black" refresh-content-action @refresh="getVariances" >
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
            ref="varianceTable"
            search
            :data="variances" >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <vs-row vs-type="flex" vs-justify="space-between">
              <vs-col vs-type="flex"  vs-justify="right" vs-align="center" vs-w="12">
                <feather-icon icon="PlusCircleIcon" class="cursor-pointer mr-5" svg-classes="h-6 w-6" @click="addNewData" v-b-tooltip.hover :title="$t('AddNew')" />
              </vs-col>
            </vs-row>
          </div>
          <template slot="thead">
            <vs-th>{{$t('Action')}}</vs-th>
            <vs-th sort-key="periodName">{{$t('MRMR.Variances.Period')}}</vs-th>
            <vs-th sort-key="submittedBy">{{$t('MRMR.Variances.SubmittedBy')}}</vs-th>
            <vs-th sort-key="submissionDate">{{$t('MRMR.Variances.SubmissionDate')}}</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td width="150px" class="whitespace-no-wrap">
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="openDeleteConfirm(tr.id)"
                  />
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ tr.periodName }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ tr.submittedBy }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ tr.submissionDate | toDate }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>
<script>

import moduleMRMR from "../store/moduleMRMR.js";

import router from '../../../../router'


import {
} from "../../../shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
  },
  data() {
    return {
      selectedMainProjectId: null
    }
  },
  computed: {
    variances() {
      return this.$store.state.mrmr.variances;
    },
    mainProjectId() {
      return Number(this.$store.state.projectId);
    }
  },

  mounted() {
    if (this.$store.state.mrmr.projects.length === 0) {
      this.$vs.loading();

      this.$store.dispatch("mrmr/fetchAllProjects").then(() => {
        if (!this.isMounted) {
          this.$refs.listCard.refreshcard();
        }
        this.isMounted = true;
      }).finally(() => {
        this.$vs.loading.close();
      })
    } 
    else if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
      this.isMounted = true;
    } 
  },

  created() {
    if (!moduleMRMR.isRegistered) {
      this.$store.registerModule("mrmr", moduleMRMR);
      moduleMRMR.isRegistered = true;
    }
  },

  watch: {
  },

  methods: {
    addNewData() {
      router.push({ name: 'mrmr-variances-upload', params: { editData: null} });
    },

    getVariances() {
      this.$store.dispatch("mrmr/fetchVariances", this.mainProjectId).finally(() => {
        this.$refs.listCard.removeRefreshAnimation()
      });
    },

    openDeleteConfirm(varianceId) {
      this.$deleteConfirmation({
        text: this.$t('MRMR.Variances.ConfirmDelete'),
        accept: () => this.deleteVariance(varianceId)
      });
    },

    deleteVariance(id) {
      this.$store.dispatch("mrmr/removeVariance", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("MRMR.Variances.VarianceDeleted"));
          this.$refs.listCard.refreshcard();
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.listCard.refreshcard();
          }
        });
    }
  }
};
</script>
<style lang="scss">
</style>
